export const createToggleAnimation = (
  rootObject,
  clipName,
  animationToggle,
  decorator = {}
) => {
  return {
    id: rootObject + "-" + clipName,
    animation: {
      ...decorator,
      rootObject: rootObject,
      clip: {
        name: clipName,
      },
    },
    animationToggle: animationToggle,
  };
};

export const createTimeAnimation = (rootObject, clipName, time) => {
  return {
    id: rootObject + "-" + clipName,
    animation: {
      // This is most likely .fbx file name (without extension)
      rootObject: rootObject,
      // animation clip
      clip: {
        name: clipName,
      },

      // animation action
      action: {
        playing: true, // this has to be true, with out it playahead time isn't updated
        time, // playahead time
        timeScale: 0, // 0 value "pauses" animation, time is not moving
      },
    },
  };
};
